export default "__VITE_ASSET__DfdTkAQy__"